import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { PngImage } from '../../../../../../shared/components/png-image';
import { getShowMyVideo } from '../../../../../../shared/features/settings';
import { isMobileUa } from '../../../../../../shared/features/uatraits/selectors';
import { getReactionIconSizes } from '../../../../../../shared/helpers/get-reaction-icon-sizes';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { ReactionType } from '../../../../../../types';
import { GRID_VIEW } from '../../../../constants';
import { getActiveGridView, getParticipantsCount, selectShouldRenderInviteBlock } from '../../../../selectors';

type Props = {
    isMainSlot: boolean;
    reactionType: ReactionType;
};

export function ReactionIcon({ isMainSlot, reactionType }: Props) {
    const activeGridView = useSelector(getActiveGridView);
    const isMobile = useSelector(isMobileUa);
    const participantsCount = useSelector(getParticipantsCount);
    const shouldRenderInviteBlock = useSelector(selectShouldRenderInviteBlock);
    const showMyVideo = useSelector(getShowMyVideo);

    useEffect(() => {
        if (reactionType === 'hand') {
            countMetrika('meeting_screen', 'hand_and_reactions', 'hand_slot_show');
        }
    }, [reactionType]);

    const gridView = shouldRenderInviteBlock ? GRID_VIEW.DEFAULT : activeGridView;
    const participantsSlotsCount = showMyVideo ? participantsCount : participantsCount - 1;
    const slotsCount = shouldRenderInviteBlock ? 2 : participantsSlotsCount;

    const { size, indent } = getReactionIconSizes(gridView, isMainSlot, isMobile, slotsCount);

    return (
        <PngImage
            name={reactionType}
            style={{ width: size, height: size, top: indent, right: indent, position: 'absolute', zIndex: 1 }}
        />
    );
}
